import React from 'react';
import { ArrowDown, MapPin, Mail, Phone, Linkedin, Download } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const positioningTags = ['Product', 'Digital Transformation', 'Data Governance', 'Secure Automation'];

  return (
    <section id="home" className="hero-section" data-testid="hero-section">
      {/* Background Image */}
      <div className="hero-background">
        <img 
          src="https://images.unsplash.com/photo-1671722294182-ed01cbe66bd1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxkYXJrJTIwcHJvZmVzc2lvbmFsJTIwb2ZmaWNlfGVufDB8fHx8MTc1NjIxMzEzMXww&ixlib=rb-4.1.0&q=85"
          alt="Professional workspace"
          className="hero-image"
        />
        <div className="hero-overlay"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-8 relative z-10">
        <div className="hero-content">
          <div className="mb-6">
            <div className="flex items-center space-x-2 mb-4">
              <MapPin className="text-text-secondary" size={16} />
              <span className="caption">Glasgow, UK</span>
            </div>
            <div className="text-indigo-300 font-semibold text-lg tracking-wide mb-2" data-testid="hero-name">
              Anna Krat
            </div>
          </div>
          
          <h1 className="hero-title mb-6" data-testid="hero-headline">
            Technical Product &<br />
            Digital Transformation<br />
            Professional
          </h1>
          
          <div className="mb-8">
            <p className="body-large mb-4" data-testid="hero-subheadline">
              Secure, data-governed and AI-enabled solutions for complex organisations
            </p>
            <p className="body-medium max-w-2xl" data-testid="hero-positioning">
              I help organisations turn complex operational, data, compliance and security challenges into secure, scalable and user-centred digital solutions.
            </p>
          </div>

          {/* Positioning tags */}
          <div className="flex flex-wrap gap-3 mb-10" data-testid="hero-tags">
            {positioningTags.map((tag, index) => (
              <span
                key={index}
                className="px-4 py-1.5 rounded-full caption text-white bg-white/10 border border-white/20 backdrop-blur-md"
              >
                {tag}
              </span>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <button 
              onClick={() => scrollToSection('impact')}
              className="btn-primary"
              data-testid="hero-view-impact-btn"
            >
              View Selected Impact
            </button>
            <a
              href="/Anna-Krat-CV.pdf"
              download="Anna-Krat-CV.pdf"
              className="btn-secondary inline-flex items-center justify-center gap-2"
              data-testid="hero-download-cv-btn"
            >
              <Download size={18} />
              Download CV (PDF)
            </a>
            <button 
              onClick={() => scrollToSection('contact')}
              className="btn-secondary"
              data-testid="hero-contact-btn"
            >
              Get In Touch
            </button>
          </div>

          {/* Quick Contact */}
          <div className="flex flex-col sm:flex-row gap-6 opacity-80">
            <div className="flex items-center space-x-2">
              <Mail size={16} className="text-text-secondary" />
              <span className="caption">anna200224@hotmail.com</span>
            </div>
            <div className="flex items-center space-x-2">
              <Phone size={16} className="text-text-secondary" />
              <span className="caption">+44 791 866 3773</span>
            </div>
            <a 
              href="https://www.linkedin.com/in/anna-krat-34a17328/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center space-x-2 hover:text-brand-primary transition-colors"
              data-testid="hero-linkedin-link"
            >
              <Linkedin size={16} className="text-text-secondary" />
              <span className="caption">LinkedIn Profile</span>
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button 
          onClick={() => scrollToSection('about')}
          className="text-white/70 hover:text-white transition-colors"
          data-testid="hero-scroll-down-btn"
        >
          <ArrowDown size={24} />
        </button>
      </div>
    </section>
  );
};

export default Hero;
